// Consent types for the data collection engine.
// See: vault/.../El Portal/research/data-collection-engine/_index.md §3

export type ConsentBucket = 'C' | 'A' | 'B';

// What version of the consent text the user agreed to.
// Bumped only when we change what we ask for, never automatically.
//
// History:
//   v1.0  — first release. Asked once at signup: save my entries so the
//           app can work for me.
//   v2.1  — added two optional choices on a welcome screen after email
//           verification: anonymous usage stats, and helping reports
//           get smarter over time.
//
// Old rows keep their old version forever. The audit trail must show
// exactly what the user saw at the moment they clicked.
export type ConsentVersion = 'consent-v1.0' | 'consent-v2.1' | 'consent-v2.1-backfill';

export const CURRENT_CONSENT_VERSION: ConsentVersion = 'consent-v2.1';

export interface ConsentRow {
  id: string;
  user_id: string;
  bucket: ConsentBucket;
  granted: boolean;
  version: ConsentVersion;
  ip_country: string | null;
  user_agent: string | null;
  ts: string;
}

export interface ConsentState {
  C: boolean;
  A: boolean;
  B: boolean;
  // True iff the user has any row for that bucket (granted or not).
  // Drives the post-verify welcome screen: once decided, never re-ask.
  decidedA: boolean;
  decidedB: boolean;
  version: ConsentVersion | null;
  loadedAt: number;
}

export const EMPTY_CONSENT: ConsentState = {
  C: false,
  A: false,
  B: false,
  decidedA: false,
  decidedB: false,
  version: null,
  loadedAt: 0,
};
